<script setup>
import { cn } from "@/shared/lib/utils";
import { Separator } from "@/shared/ui/separator";

const props = defineProps({
  class: { type: [String, Object, Array], default: undefined },
});
</script>

<template>
  <Separator
    orientation="vertical"
    data-slot="action-bar-separator"
    :class="cn('mx-1 h-1/2', props.class)"
  />
</template>
